module.exports = __webpack_public_path__ + "static/img/video2.ca1cacd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video2.jpg
// module id = +4IN
// module chunks = 10